<template>
	<pop-up-wrapper>
		<div class="slider-pop-up slider-key-pop-up">
			<span @click="prev" id="left" class="btn">
				<span></span>
			</span>
			<span @click="next" id="right" class="btn">
				<span></span>
			</span>
			<div class="slide" v-for="i in [currentSlide]" :key="i">
				<img
					class="close"
					@click="this.$emit('close')"
					src="/img/close-white.png"
					alt=""
				/>
				<div class="fake-img"></div>
				<img :src="currentImg" alt="" />
			</div>
			<div class="button-row">
				<button
					v-if="this.notice"
					class="submit dark"
					@click="showNoticeFile"
				>
					Notice (aperçu)
				</button>
			</div>
			<FilePreview
				:show="showNotice"
				:filePath="notice"
				title="Aperçu de la notice (première page uniquement)"
				@close="closeNotice"
				@error="handlePreviewError"
			/>
		</div>
	</pop-up-wrapper>
</template>

<script>
import { authenticatedImageFetch } from "../../../utils/utils";
import PopUpWrapper from "../../PopUp/PopUpWrapper.vue";
import FilePreview from "../../FilePreview/FilePreview.vue";
export default {
	components: { PopUpWrapper, FilePreview },
	props: {
		image1: String,
		image2: String,
		image3: String,
		image4: String,
		image5: String,
		image6: String,
		image7: String,
		image8: String,
		image9: String,
		image10: String,
		notice: String
	},
	data() {
		return {
			currentSlide: 0,
			images: [],
			showNotice: false
		};
	},
	methods: {
		next() {
			this.currentSlide += 1;
			this.$emit(
				"index",
				Math.abs(this.currentSlide) % this.images.length
			);
		},
		prev() {
			this.currentSlide -= 1;
			this.$emit(
				"index",
				Math.abs(this.currentSlide) % this.images.length
			);
		},
		getImage(file, index) {
			authenticatedImageFetch(file, {
				method: "GET"
			})
				.then(response => response.blob())
				.then(blob => {
					const reader = new FileReader();
					const component = this;
					reader.onload = function() {
						const img = new Image();
						img.src = this.result;
						component.images[index] = img.src;
					};
					reader.readAsDataURL(blob);
				});
		},
		addIndex: function(e) {
			if (e.code == "ArrowRight" || e.code == "Space") {
				this.next();
			}
			if (e.code == "ArrowLeft" || e === false) {
				this.prev();
			}
		},
		handlePreviewError(error) {
			console.error("Erreur lors de l'affichage de l'aperçu:", error);
		},
		showNoticeFile() {
			this.showNotice = true;
		},
		closeNotice() {
			this.showNotice = false;
		}
	},
	computed: {
		currentImg() {
			return this.images[
				Math.abs(this.currentSlide) % this.images.length
			];
		}
	},
	mounted() {
		this.images = [
			this.image1,
			this.image2,
			this.image3,
			this.image4,
			this.image5,
			this.image6,
			this.image7,
			this.image8,
			this.image9,
			this.image10
		];
		this.images = this.images.filter(el => {
			return el !== null && typeof el !== "undefined";
		});
		this.images.forEach((e, index) => {
			this.getImage(e, index);
		});

		window.addEventListener("keyup", e => this.addIndex(e));
	},
};
</script>
<style scoped>
:deep(.pop-up) {
	background: transparent !important;
	box-shadow: none !important;
	padding: 0 !important;
	border-radius: 0 !important;
}
.slider-key-pop-up {
	width: 60vw;
	max-width: 900px;
	min-width: 500px;
	margin-left: 260px;
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	margin-right: auto;
	margin-top: 40px;
	margin-bottom: auto;
}

@media (max-width: 900px) {
	.slider-key-pop-up {
		width: 95vw;
		min-width: unset;
		margin-left: 0;
	}
}


</style>
